import { render } from "./LineChart.vue?vue&type=template&id=2c9d4e08"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
script.render = render

export default script